import { gql } from '@apollo/client';

const GET_CONTRACT_FILE_POST_URL_MUTATION = gql`
  mutation GetContractPostUrl($input: GetContractFilePostUrlInput!) {
    getContractFilePostUrl(input: $input)
  }
`;

export default GET_CONTRACT_FILE_POST_URL_MUTATION;
